// Traduções de Multas, a tela do Abastecimento e a leitura do DP (27/10/2026).
// Coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'multas.titulo': 'Multas',
    'multas.eyebrow': 'Central de Informações',
    'multas.ajuda.lancamento': 'O setor de abastecimento lança cada auto de infração com o veículo, o condutor e os comprovantes. A multa cai no DP, que só consulta. A penalidade do mesmo auto atualiza a multa da autuação.',
    'multas.ajuda.dp': 'As multas que o setor de abastecimento lança, com o condutor, o valor a descontar e os comprovantes. O DP consulta; quem lança e corrige é o abastecimento.',
    'multas.kpi.total': 'Lançadas',
    'multas.kpi.valor': 'Valor das multas',
    'multas.kpi.desconto': 'A descontar',
    'multas.kpi.sem_condutor': 'Sem condutor',
    'multas.kpi.indicacao': 'Indicação em 7 dias',
    'multas.kpi.vencendo': 'Vencem em 7 dias',
    'multas.lancar': 'Lançar multa',
    'multas.excel': 'Excel',
    'multas.filtro.de': 'De',
    'multas.filtro.ate': 'Até',
    'multas.filtro.gravidade': 'Gravidade',
    'multas.filtro.situacao': 'Situação',
    'multas.filtro.todas': 'Todas',
    'multas.situacao.lancada': 'Lançadas',
    'multas.situacao.cancelada': 'Canceladas',
    'multas.situacao.todas': 'Todas',
    'multas.col.infracao': 'Infração',
    'multas.col.auto': 'Auto',
    'multas.col.veiculo': 'Veículo',
    'multas.col.condutor': 'Condutor',
    'multas.col.valores': 'Valores',
    'multas.col.prazos': 'Prazos',
    'multas.col.acoes': 'Ações',
    'multas.gravidade.leve': 'Leve',
    'multas.gravidade.media': 'Média',
    'multas.gravidade.grave': 'Grave',
    'multas.gravidade.gravissima': 'Gravíssima',
    'multas.pontos': '{{n}} pontos',
    'multas.tipo.cavalo': 'Cavalo',
    'multas.tipo.carreta': 'Carreta',
    'multas.tipo.leve': 'Veículo leve',
    'multas.tipo.maquina': 'Máquina',
    'multas.tipo.outro': 'Outro',
    'multas.fonte.rastreador': 'Rastreador',
    'multas.fonte.carga': 'Carga da Frente',
    'multas.fonte.viagem': 'Viagem do Protheus',
    'multas.fonte.abastecimento': 'Abastecimento',
    'multas.fonte.conjunto': 'Conjunto atual',
    'multas.fonte.manual': 'Escolhido à mão',
    'multas.fase.autuacao': 'Autuação',
    'multas.fase.penalidade': 'Penalidade',
    'multas.responsavel.motorista': 'Motorista',
    'multas.responsavel.empresa': 'Empresa',
    'multas.semCondutor': 'Sem condutor',
    'multas.cancelada': 'Cancelada',
    'multas.indicado': 'Condutor indicado',
    'multas.empresaPaga': 'Empresa paga',
    'multas.comprovantes': '{{n}} comprovantes',
    'multas.ver': 'Ver',
    'multas.editar': 'Editar',
    'multas.cancelar': 'Cancelar multa',
    'multas.fechar': 'Fechar',
    'multas.semResultado': 'Nenhuma multa neste filtro',
    'multas.form.tituloNova': 'Lançar multa',
    'multas.form.tituloEdicao': 'Editar a multa {{auto}}',
    'multas.secao.auto': 'Auto de infração',
    'multas.secao.veiculo': 'Veículo e condutor',
    'multas.secao.infracao': 'Infração',
    'multas.secao.valores': 'Valores e prazos',
    'multas.secao.desconto': 'Desconto',
    'multas.secao.comprovantes': 'Comprovantes',
    'multas.campo.numero': 'Número do auto',
    'multas.campo.orgao': 'Órgão autuador',
    'multas.campo.fase': 'Fase',
    'multas.campo.dataHora': 'Data e hora da infração',
    'multas.campo.veiculo': 'Veículo autuado',
    'multas.campo.condutor': 'Condutor',
    'multas.campo.codigo': 'Código da infração',
    'multas.campo.descricao': 'Descrição da infração',
    'multas.campo.amparo': 'Amparo legal',
    'multas.campo.gravidade': 'Gravidade',
    'multas.campo.fator': 'Fator multiplicador',
    'multas.campo.pontos': 'Pontos',
    'multas.campo.local': 'Local',
    'multas.campo.municipio': 'Município',
    'multas.campo.uf': 'UF',
    'multas.campo.valor': 'Valor da multa',
    'multas.campo.valorComDesconto': 'Valor com desconto',
    'multas.campo.vencimento': 'Vencimento',
    'multas.campo.prazoIndicacao': 'Prazo para indicar o condutor',
    'multas.campo.condutorIndicado': 'Condutor indicado ao órgão',
    'multas.campo.responsavel': 'Quem paga',
    'multas.campo.valorDesconto': 'Valor a descontar',
    'multas.campo.observacao': 'Observação ao DP',
    'multas.form.sugestao': 'Quem estava com o veículo nessa hora',
    'multas.form.semSugestao': 'Nenhum registro aponta quem dirigia nessa hora. Escolha o condutor.',
    'multas.form.escolherVeiculo': 'Escolha o veículo e a hora para o Hub dizer quem dirigia.',
    'multas.form.buscando': 'Procurando quem dirigia',
    'multas.form.preenchido': 'Condutor sugerido pela fonte {{fonte}}',
    'multas.busca': 'Auto, placa, condutor ou código',
    'multas.form.semIdentificar': 'Sem condutor identificado',
    'multas.form.menos20': 'Menos 20%',
    'multas.form.menos40': 'Menos 40%',
    'multas.form.sugeridoCtb': 'CTB: {{valor}}',
    'multas.form.lancar': 'Lançar',
    'multas.form.salvar': 'Salvar',
    'multas.form.obrigatorio': 'Informe o número do auto, a data e a hora e o veículo.',
    'multas.form.enviando': 'Enviando comprovante {{atual}} de {{total}}',
    'multas.form.falhou': 'A multa está salva, mas alguns comprovantes não subiram. Tente de novo.',
    'multas.form.salva': 'Multa salva',
    'multas.form.lancada': 'Multa lançada',
    'multas.anexos.recusa.limite': 'A multa já tem 10 comprovantes',
    'multas.anexos.nenhum': 'Nenhum comprovante',
    'multas.anexos.removido': 'Comprovante removido',
    'multas.detalhe.lancadaPor': 'Lançada por {{nome}} em {{data}}',
    'multas.detalhe.atualizadaPor': 'Atualizada por {{nome}} em {{data}}',
    'multas.detalhe.canceladaPor': 'Cancelada por {{nome}} em {{data}}',
    'multas.detalhe.motivo': 'Motivo do cancelamento',
    'multas.cancelarDialogo.titulo': 'Cancelar a multa {{auto}}',
    'multas.cancelarDialogo.explica': 'A multa sai das lançadas e do DP, e fica no histórico com o motivo.',
    'multas.cancelarDialogo.motivo': 'Motivo',
    'multas.cancelarDialogo.ok': 'Multa cancelada',
  },
  en: {
    'multas.titulo': 'Traffic fines',
    'multas.eyebrow': 'Information Center',
    'multas.ajuda.lancamento': 'The fueling team enters each traffic ticket with the vehicle, the driver and the receipts. The fine reaches the Personnel Department, which only views it. The penalty notice of the same ticket updates the original fine.',
    'multas.ajuda.dp': 'The fines entered by the fueling team, with the driver, the amount to deduct and the receipts. The Personnel Department views them; the fueling team enters and corrects.',
    'multas.kpi.total': 'Entered',
    'multas.kpi.valor': 'Fine amount',
    'multas.kpi.desconto': 'To deduct',
    'multas.kpi.sem_condutor': 'No driver',
    'multas.kpi.indicacao': 'Naming within 7 days',
    'multas.kpi.vencendo': 'Due within 7 days',
    'multas.lancar': 'Enter fine',
    'multas.excel': 'Excel',
    'multas.filtro.de': 'From',
    'multas.filtro.ate': 'To',
    'multas.filtro.gravidade': 'Severity',
    'multas.filtro.situacao': 'Status',
    'multas.filtro.todas': 'All',
    'multas.situacao.lancada': 'Entered',
    'multas.situacao.cancelada': 'Canceled',
    'multas.situacao.todas': 'All',
    'multas.col.infracao': 'Violation',
    'multas.col.auto': 'Ticket',
    'multas.col.veiculo': 'Vehicle',
    'multas.col.condutor': 'Driver',
    'multas.col.valores': 'Amounts',
    'multas.col.prazos': 'Deadlines',
    'multas.col.acoes': 'Actions',
    'multas.gravidade.leve': 'Light',
    'multas.gravidade.media': 'Medium',
    'multas.gravidade.grave': 'Serious',
    'multas.gravidade.gravissima': 'Very serious',
    'multas.pontos': '{{n}} points',
    'multas.tipo.cavalo': 'Tractor',
    'multas.tipo.carreta': 'Trailer',
    'multas.tipo.leve': 'Light vehicle',
    'multas.tipo.maquina': 'Machine',
    'multas.tipo.outro': 'Other',
    'multas.fonte.rastreador': 'Tracker',
    'multas.fonte.carga': 'Work front load',
    'multas.fonte.viagem': 'Protheus trip',
    'multas.fonte.abastecimento': 'Fueling',
    'multas.fonte.conjunto': 'Current set',
    'multas.fonte.manual': 'Chosen by hand',
    'multas.fase.autuacao': 'Notice',
    'multas.fase.penalidade': 'Penalty',
    'multas.responsavel.motorista': 'Driver',
    'multas.responsavel.empresa': 'Company',
    'multas.semCondutor': 'No driver',
    'multas.cancelada': 'Canceled',
    'multas.indicado': 'Driver named',
    'multas.empresaPaga': 'Company pays',
    'multas.comprovantes': '{{n}} receipts',
    'multas.ver': 'View',
    'multas.editar': 'Edit',
    'multas.cancelar': 'Cancel fine',
    'multas.fechar': 'Close',
    'multas.semResultado': 'No fines in this filter',
    'multas.form.tituloNova': 'Enter fine',
    'multas.form.tituloEdicao': 'Edit fine {{auto}}',
    'multas.secao.auto': 'Traffic ticket',
    'multas.secao.veiculo': 'Vehicle and driver',
    'multas.secao.infracao': 'Violation',
    'multas.secao.valores': 'Amounts and deadlines',
    'multas.secao.desconto': 'Deduction',
    'multas.secao.comprovantes': 'Receipts',
    'multas.campo.numero': 'Ticket number',
    'multas.campo.orgao': 'Issuing authority',
    'multas.campo.fase': 'Stage',
    'multas.campo.dataHora': 'Violation date and time',
    'multas.campo.veiculo': 'Vehicle',
    'multas.campo.condutor': 'Driver',
    'multas.campo.codigo': 'Violation code',
    'multas.campo.descricao': 'Violation description',
    'multas.campo.amparo': 'Legal basis',
    'multas.campo.gravidade': 'Severity',
    'multas.campo.fator': 'Multiplier',
    'multas.campo.pontos': 'Points',
    'multas.campo.local': 'Location',
    'multas.campo.municipio': 'City',
    'multas.campo.uf': 'State',
    'multas.campo.valor': 'Fine amount',
    'multas.campo.valorComDesconto': 'Discounted amount',
    'multas.campo.vencimento': 'Due date',
    'multas.campo.prazoIndicacao': 'Deadline to name the driver',
    'multas.campo.condutorIndicado': 'Driver named to the authority',
    'multas.campo.responsavel': 'Who pays',
    'multas.campo.valorDesconto': 'Amount to deduct',
    'multas.campo.observacao': 'Note to Personnel',
    'multas.form.sugestao': 'Who had the vehicle at that time',
    'multas.form.semSugestao': 'No record shows who was driving at that time. Choose the driver.',
    'multas.form.escolherVeiculo': 'Choose the vehicle and the time for the Hub to tell who was driving.',
    'multas.form.buscando': 'Looking for the driver',
    'multas.form.preenchido': 'Driver suggested by {{fonte}}',
    'multas.busca': 'Ticket, plate, driver or code',
    'multas.form.semIdentificar': 'No driver identified',
    'multas.form.menos20': 'Less 20%',
    'multas.form.menos40': 'Less 40%',
    'multas.form.sugeridoCtb': 'Traffic code: {{valor}}',
    'multas.form.lancar': 'Enter',
    'multas.form.salvar': 'Save',
    'multas.form.obrigatorio': 'Enter the ticket number, the date and time and the vehicle.',
    'multas.form.enviando': 'Uploading receipt {{atual}} of {{total}}',
    'multas.form.falhou': 'The fine is saved, but some receipts did not upload. Try again.',
    'multas.form.salva': 'Fine saved',
    'multas.form.lancada': 'Fine entered',
    'multas.anexos.recusa.limite': 'The fine already has 10 receipts',
    'multas.anexos.nenhum': 'No receipts',
    'multas.anexos.removido': 'Receipt removed',
    'multas.detalhe.lancadaPor': 'Entered by {{nome}} on {{data}}',
    'multas.detalhe.atualizadaPor': 'Updated by {{nome}} on {{data}}',
    'multas.detalhe.canceladaPor': 'Canceled by {{nome}} on {{data}}',
    'multas.detalhe.motivo': 'Cancellation reason',
    'multas.cancelarDialogo.titulo': 'Cancel fine {{auto}}',
    'multas.cancelarDialogo.explica': 'The fine leaves the entered list and the Personnel view, and stays in the history with the reason.',
    'multas.cancelarDialogo.motivo': 'Reason',
    'multas.cancelarDialogo.ok': 'Fine canceled',
  },
  es: {
    'multas.titulo': 'Multas',
    'multas.eyebrow': 'Central de Información',
    'multas.ajuda.lancamento': 'El sector de abastecimiento registra cada acta de infracción con el vehículo, el conductor y los comprobantes. La multa llega al departamento de personal, que solo la consulta. La sanción de la misma acta actualiza la multa original.',
    'multas.ajuda.dp': 'Las multas que registra el sector de abastecimiento, con el conductor, el valor a descontar y los comprobantes. Personal consulta; abastecimiento registra y corrige.',
    'multas.kpi.total': 'Registradas',
    'multas.kpi.valor': 'Valor de las multas',
    'multas.kpi.desconto': 'A descontar',
    'multas.kpi.sem_condutor': 'Sin conductor',
    'multas.kpi.indicacao': 'Indicación en 7 días',
    'multas.kpi.vencendo': 'Vencen en 7 días',
    'multas.lancar': 'Registrar multa',
    'multas.excel': 'Excel',
    'multas.filtro.de': 'Desde',
    'multas.filtro.ate': 'Hasta',
    'multas.filtro.gravidade': 'Gravedad',
    'multas.filtro.situacao': 'Situación',
    'multas.filtro.todas': 'Todas',
    'multas.situacao.lancada': 'Registradas',
    'multas.situacao.cancelada': 'Canceladas',
    'multas.situacao.todas': 'Todas',
    'multas.col.infracao': 'Infracción',
    'multas.col.auto': 'Acta',
    'multas.col.veiculo': 'Vehículo',
    'multas.col.condutor': 'Conductor',
    'multas.col.valores': 'Valores',
    'multas.col.prazos': 'Plazos',
    'multas.col.acoes': 'Acciones',
    'multas.gravidade.leve': 'Leve',
    'multas.gravidade.media': 'Media',
    'multas.gravidade.grave': 'Grave',
    'multas.gravidade.gravissima': 'Gravísima',
    'multas.pontos': '{{n}} puntos',
    'multas.tipo.cavalo': 'Tractor',
    'multas.tipo.carreta': 'Remolque',
    'multas.tipo.leve': 'Vehículo liviano',
    'multas.tipo.maquina': 'Máquina',
    'multas.tipo.outro': 'Otro',
    'multas.fonte.rastreador': 'Rastreador',
    'multas.fonte.carga': 'Carga del frente',
    'multas.fonte.viagem': 'Viaje de Protheus',
    'multas.fonte.abastecimento': 'Abastecimiento',
    'multas.fonte.conjunto': 'Conjunto actual',
    'multas.fonte.manual': 'Elegido a mano',
    'multas.fase.autuacao': 'Notificación',
    'multas.fase.penalidade': 'Sanción',
    'multas.responsavel.motorista': 'Conductor',
    'multas.responsavel.empresa': 'Empresa',
    'multas.semCondutor': 'Sin conductor',
    'multas.cancelada': 'Cancelada',
    'multas.indicado': 'Conductor indicado',
    'multas.empresaPaga': 'Paga la empresa',
    'multas.comprovantes': '{{n}} comprobantes',
    'multas.ver': 'Ver',
    'multas.editar': 'Editar',
    'multas.cancelar': 'Cancelar multa',
    'multas.fechar': 'Cerrar',
    'multas.semResultado': 'Ninguna multa en este filtro',
    'multas.form.tituloNova': 'Registrar multa',
    'multas.form.tituloEdicao': 'Editar la multa {{auto}}',
    'multas.secao.auto': 'Acta de infracción',
    'multas.secao.veiculo': 'Vehículo y conductor',
    'multas.secao.infracao': 'Infracción',
    'multas.secao.valores': 'Valores y plazos',
    'multas.secao.desconto': 'Descuento',
    'multas.secao.comprovantes': 'Comprobantes',
    'multas.campo.numero': 'Número del acta',
    'multas.campo.orgao': 'Órgano emisor',
    'multas.campo.fase': 'Etapa',
    'multas.campo.dataHora': 'Fecha y hora de la infracción',
    'multas.campo.veiculo': 'Vehículo',
    'multas.campo.condutor': 'Conductor',
    'multas.campo.codigo': 'Código de la infracción',
    'multas.campo.descricao': 'Descripción de la infracción',
    'multas.campo.amparo': 'Base legal',
    'multas.campo.gravidade': 'Gravedad',
    'multas.campo.fator': 'Multiplicador',
    'multas.campo.pontos': 'Puntos',
    'multas.campo.local': 'Lugar',
    'multas.campo.municipio': 'Municipio',
    'multas.campo.uf': 'Estado',
    'multas.campo.valor': 'Valor de la multa',
    'multas.campo.valorComDesconto': 'Valor con descuento',
    'multas.campo.vencimento': 'Vencimiento',
    'multas.campo.prazoIndicacao': 'Plazo para indicar al conductor',
    'multas.campo.condutorIndicado': 'Conductor indicado al órgano',
    'multas.campo.responsavel': 'Quién paga',
    'multas.campo.valorDesconto': 'Valor a descontar',
    'multas.campo.observacao': 'Observación para Personal',
    'multas.form.sugestao': 'Quién tenía el vehículo a esa hora',
    'multas.form.semSugestao': 'Ningún registro indica quién conducía a esa hora. Elija al conductor.',
    'multas.form.escolherVeiculo': 'Elija el vehículo y la hora para que el Hub diga quién conducía.',
    'multas.form.buscando': 'Buscando al conductor',
    'multas.form.preenchido': 'Conductor sugerido por la fuente {{fonte}}',
    'multas.busca': 'Acta, placa, conductor o código',
    'multas.form.semIdentificar': 'Sin conductor identificado',
    'multas.form.menos20': 'Menos 20%',
    'multas.form.menos40': 'Menos 40%',
    'multas.form.sugeridoCtb': 'Código de tránsito: {{valor}}',
    'multas.form.lancar': 'Registrar',
    'multas.form.salvar': 'Guardar',
    'multas.form.obrigatorio': 'Informe el número del acta, la fecha y la hora y el vehículo.',
    'multas.form.enviando': 'Enviando comprobante {{atual}} de {{total}}',
    'multas.form.falhou': 'La multa está guardada, pero algunos comprobantes no subieron. Intente de nuevo.',
    'multas.form.salva': 'Multa guardada',
    'multas.form.lancada': 'Multa registrada',
    'multas.anexos.recusa.limite': 'La multa ya tiene 10 comprobantes',
    'multas.anexos.nenhum': 'Ningún comprobante',
    'multas.anexos.removido': 'Comprobante quitado',
    'multas.detalhe.lancadaPor': 'Registrada por {{nome}} el {{data}}',
    'multas.detalhe.atualizadaPor': 'Actualizada por {{nome}} el {{data}}',
    'multas.detalhe.canceladaPor': 'Cancelada por {{nome}} el {{data}}',
    'multas.detalhe.motivo': 'Motivo de la cancelación',
    'multas.cancelarDialogo.titulo': 'Cancelar la multa {{auto}}',
    'multas.cancelarDialogo.explica': 'La multa sale de las registradas y de Personal, y queda en el historial con el motivo.',
    'multas.cancelarDialogo.motivo': 'Motivo',
    'multas.cancelarDialogo.ok': 'Multa cancelada',
  },
}
